import store from 'redux/store';
import onBehalfAction from 'redux/actions/onBehalfAction';
import { REST_METHOD, REST_URL } from '../constants';
import { requestPCL, requestProvisioning } from './api';

export interface CreateBoomiRequestParams {
  request_type: string;
  group_name: string;
  user_upn: string;
  app_name?: string;
  approval_required: string;
  user_sys_id: string;
  user_email: string;
  user_name?: string;
  user_first_name: string;
  requestor_sys_id?: string;
  requestor_email?: string;
  requestor_first_name?: string;
  // Need approval
  approver_email?: string;
  approver_sys_id?: string;
  approver_first_name?: string;
  cost_center?: string;
  business_justification?: string;
  // Delegation
  delegated?: string;
  delegated_to_email?: string;
  delegation_end_date?: string;
}

const pcProcessingWorkFlow = {
  PcProcessing: async (params: any, isLogged: boolean = true) => {
    try {
      const requestParams = {
        url: `${REST_URL.PC_LIFECYCLE_REQUEST}`,
        method: `${REST_METHOD.POST}`,
        data: { ...params }
      };

      const response = await requestPCL(requestParams);
      const responseData = response.data;

      if (isLogged && responseData) {
        store.dispatch(onBehalfAction.uptimeAuditLog({
          action: 'CREATE',
          type: params?.request_type,
          detail: responseData?.Ritm_number,
        }));
      }

      return responseData;
    } catch (error) {
      console.error('Error', JSON.stringify(error));
      return null;
    }
  },
  getPCAcknowledgeNoScanReason: async () => {
    try {
      const requestParams = {
        url: `${REST_URL.PC_ACKNOWLEDGE_DEVICE}${REST_URL.NO_SCAN_REASON}`,
        method: `${REST_METHOD.GET}`,
      };

      const response = await requestPCL(requestParams);
      return response.data;
    } catch (error) {
      console.error('Error', JSON.stringify(error));
      return null;
    }
  },
  createVirtualAppRequest: async (params: CreateBoomiRequestParams, isLogged: boolean = true) => {
    try {
      const requestParams = {
        url: `${REST_URL.VIRTUAL_APP}`,
        method: `${REST_METHOD.POST}`,
        data: params,
      };

      await requestProvisioning(requestParams);

      if (isLogged) {
        store.dispatch(onBehalfAction.uptimeAuditLog({
          action: 'ADD_GROUP',
          type: params.request_type,
          detail: params.group_name,
        }));
      }

      return true;
    } catch (error) {
      console.log('Failed to create boomi request', error);
      return false;
    }
  },

  createVirtualDesktopRequest: async (params: CreateBoomiRequestParams, isLogged: boolean = true) => {
    try {
      const requestParams = {
        url: `${REST_URL.VIRTUAL_DESKTOP}`,
        method: `${REST_METHOD.POST}`,
        data: params,
      };

      await requestProvisioning(requestParams);

      if (isLogged) {
        store.dispatch(onBehalfAction.uptimeAuditLog({
          action: 'ADD_GROUP',
          type: params.request_type,
          detail: params.group_name,
        }));
      }

      return true;
    } catch (error) {
      console.log('Failed to create boomi request', error);
      return false;
    }
  }
};



export default pcProcessingWorkFlow;
